/*

 Copyright (c) 2023-2025, IP Agent AI Inc.  All rights reserved.


 IMPORTANT - PLEASE READ THIS CAREFULLY BEFORE ATTEMPTING TO USE ANY SOFTWARE,

 DOCUMENTATION, OR OTHER MATERIALS.

 This software is the confidential and proprietary information of IP Agent AI Inc

 ("Confidential Information") and is protected by applicable copyright or other

 intellectual property laws and treaties. All title and ownership rights in and

 to the software (including but not limited to any source code, images,

 photographs, animations, video, audio, music, text embedded in the software),

 the intellectual property embodied in the software, and any trademarks or

 service marks of IP Agent AI Inc. that are used in connection with the

 software, are and shall at all times remain exclusively owned by IP Agent AI,

 Inc. and its licensors.  Under no circumstances shall you disclose such

 Confidential Information and trade secrets, distribute, disclose or otherwise

 make available to any third party any portion of the software's source code

 and shall use it only in accordance with the terms of the license agreement

 enclosed with this product or as entered into with IP Agent AI, Inc.


 You are prohibited from any attempt to disassemble the code, or attempt in

 any manner to reconstruct, discover, reuse or modify any source code or

 underlying algorithms of the software.


 THIS SOFTWARE IS PROVIDED "AS IS" AND THERE ARE NO WARRANTIES, CLAIMS OR

 REPRESENTATIONS MADE BY IP Agent AI, INC., OR ITS LICENSORS, SUBSIDIARIES

 AND AFFILIATES, EITHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING WARRANTIES

 OF QUALITY, PERFORMANCE, NON-INFRINGEMENT, MERCHANTABILITY, OR FITNESS FOR

 A PARTICULAR PURPOSE, NOR ARE THERE ANY WARRANTIES CREATED BY COURSE OF

 DEALING, COURSE OF PERFORMANCE, OR TRADE USAGE. IP Agent AI, INC. DOES NOT

 WARRANT THAT THIS SOFTWARE WILL MEET ANY CLIENT'S NEEDS OR BE FREE FROM

 ERRORS, OR THAT THE OPERATION OF THE SOFTWARE WILL BE UNINTERRUPTED.
*/

import AppDevelopment from "./Animations/appDevelopment.json";
import CustomerService from "./Animations/customer_service.json";
import CustomerSupportDepartment from "./Animations/customer_support_department.json";
import Dashboard from "./Animations/dashboard.json";
import Financial from "./Animations/financial.json";
import FourHoop from "./Animations/four_hoop.json";
import HealthCare from "./Animations/healthcare.json";
import HRDepartment from "./Animations/hr_department.json";
import Manufacturing from "./Animations/manufacturing.json";
import Moon from "./Animations/moon.json";
import Planet from "./Animations/planet.json";
import Insurance from "./Animations/insurance.json";
import SaleTeam from "./Animations/sale_team.json";
import Searching from "./Animations/searching.json";
import Telecom from "./Animations/telecom.json";
import Welcome from "./Animations/welcome.json";
import WelcomeBlue from "./Animations/welcome_blue.json";
import PageNotFound from "./Animations/404Error.json";
import SendingMessage from "./Animations/sendingMessage.json";
import SuccessMark from "./Animations/successMark.json";
import Fail from "./Animations/fail.json";
import Info from "./Animations/info.json";
import Infona from "./Animations/infona.json";
import Plan from "./Animations/business-planning-by-manager.json";
import TimeManagement from "./Animations/timeManagement.json";
import Agriculture from "./Animations/agriculture.json";
import Retail from "./Animations/retail.json";
import Marketing from "./Animations/marketing.json";
import Hospitality from "./Animations/hospitality.json";
import IT from "./Animations/IT.json";
import PublicSector from "./Animations/publicSector.json";
import Entertainment from "./Animations/entertainment.json";
import FMCG from "./Animations/fmcg.json";
import Science from "./Animations/science.json";
import RealEstate from "./Animations/realEstate.json";
import Aerospace from "./Animations/aerospace.json";
import Transportation from "./Animations/transportation.json";
import Construction from "./Animations/construction.json";
import Misc from "./Animations/misc.json";
import SocialMedia from "./Animations/socailMedia.json";
import SocialMediaAdvertisement from "./Animations/socialMediaAdvertisement.json";
import PublicService from "./Animations/publicService.json";
import Tourism from "./Animations/tourism.json";
import EmptySearchResult from "./Animations/emptySearchResult.json";
import EmptyResult from "./Animations/emptyImage.json";
import EmptyBlog from "./Animations/noblog.json";

export const AnimationList = {
    AppDevelopment,
    CustomerService,
    CustomerSupportDepartment,
    Dashboard,
    EmptyResult,
    EmptySearchResult,

    Financial,
    FourHoop,
    HealthCare,
    HRDepartment,
    Manufacturing,
    Moon,
    Planet,
    Insurance,
    SaleTeam,
    Searching,
    Telecom,
    Welcome,
    WelcomeBlue,
    PageNotFound,
    SendingMessage,
    SuccessMark,
    Fail,
    Info,
    Infona,
    Plan,
    TimeManagement,
    Agriculture,
    Retail,
    Marketing,
    Hospitality,
    IT,
    PublicSector,
    Entertainment,
    FMCG,
    Science,
    RealEstate,
    Aerospace,
    Transportation,
    Construction,
    Misc,
    SocialMedia,
    SocialMediaAdvertisement,
    PublicService,
    Tourism,
    EmptyBlog
}
